import { createContext, useContext, useState } from "react";

const SidebarContext = createContext();

export function SidebarProvider({ children }) {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const toggleSidebar = () =>
        setIsSidebarOpen(prev => !prev);

    return (
        <SidebarContext.Provider value={{ 
            isSidebarOpen, 
            toggleSidebar}}>
            {children}
        </SidebarContext.Provider>
    );
}

export function useSidebar() {
    return useContext(SidebarContext);
}
